export interface PageData {
  id: string;
  title: string;
  sections: Array<{
    type: string;
    props: any;
  }>;
}

export const pagesData: Record<string, PageData> = {
  home: {
    id: "home",
    title: "الصفحة الرئيسية",
    sections: [
      {
        type: "HeroSection",
        props: {
          headline: {
            ar: "شركة مكة البركة للمقاولات العامة",
            en: "Mecca El Baraka For Construction"
          },
          subheadline: {
            ar: "نبني المستقبل بالنزاهة والخبرة. حلول متكاملة في المقاولات والمحاجر بمصر والشرق الأوسط.",
            en: "Building the future with integrity and expertise. Complete solutions in construction, contracting, and quarrying in Egypt and the Middle East."
          },
          images: [
            "/images/image1.jpg",
            "/images/image2.jpg",
            "/images/image3.jpg",
            "/images/image4.jpg"
          ]
        }
      },
      { type: "VisionMissionSection", props: {} },
      { type: "AboutPreview", props: {} },
      { type: "ServicesSection", props: {} },
      { type: "ImpactSection", props: {} },
      { type: "ProjectsSection", props: {} },
      { type: "WhyChooseUs", props: {} },
      { type: "NewsSection", props: {} },
      { type: "ContactCallout", props: {} },
      { type: "MapSection", props: {} }
    ]
  },
  about: {
    id: "about",
    title: "من نحن",
    sections: [
      {
        type: "AboutHeroSection",
        props: {
          titleAr: "مكة البركة للمقاولات العامة",
          titleEn: "Mecca El Baraka For Construction",
          subtitleAr: "نبني المستقبل بالجودة والخبرة والحلول المتكاملة في المقاولات والمحاجر بمصر والشرق الأوسط",
          subtitleEn: "Building the Future with Quality, Expertise and Integrated Solutions in Construction and Quarries in Egypt and the Middle East",
          backgroundImage: "/images/about-hero.jpg"
        }
      },
      {
        type: "AboutCompanyOverviewSection",
        props: {
          titleAr: "عن الشركة",
          titleEn: "About Us",
          contentAr: "تأسست شركة مكة البركة للمقاولات العامة عام 2014 في جمهورية مصر العربية لتلبية احتياجات المنطقة العربية في النهضة بالبنية التحتية ومواكبة التطور العالمي، وشاركت الشركة في مشاريع وطنية ضخمة، مثل مشروع قناة السويس الجديدة، واكتسبت سمعة قوية بين الشركات. تخصصت الشركة في أعمال الطرق والمحاجر، وحققت رضا العملاء عبر الالتزام بالجودة والسلامة.",
          contentEn: "Mecca El Baraka For Construction was established in 2014 in the Arab Republic of Egypt to meet the needs of the Arab region in advancing infrastructure and keeping pace with global development. The company has participated in massive national projects, such as the New Suez Canal project, and has gained a strong reputation among companies. The company specialized in road works and quarries, achieving customer satisfaction through commitment to quality and safety.",
          image: "/images/image1.jpg"
        }
      },
      {
        type: "AboutQualitySafetySection",
        props: {
          titleAr: "سياسة الجودة والأمان",
          titleEn: "Quality & Safety Policy",
          contentAr: "الجودة والأمان هما أساس أعمالنا. نطبق أحدث نظم الجودة والسلامة ونعمل على تحسينها باستمرار لضمان أعلى مستويات الكفاءة وتحقيق متطلبات عملائنا، مع رقابة دورية وإجراءات دقيقة للفحص والمتابعة.",
          contentEn: "Quality and safety are the foundation of our work. We apply the latest quality and safety systems and continuously work to improve them to ensure the highest levels of efficiency and meet our clients' requirements, with periodic monitoring and precise procedures for inspection and follow-up.",
          image: "/images/image2.jpg"
        }
      },
      {
        type: "AboutProjectManagementSection",
        props: {
          titleAr: "إدارة المشاريع",
          titleEn: "Project Management",
          contentAr: "ننجح في إدارة المشاريع عبر التركيز على عناصر الوقت، الجودة، والتكلفة، واستخدام حلول إدارية وتقنية حديثة تضمن تنفيذ المشاريع بكفاءة واحترافية.",
          contentEn: "We succeed in project management by focusing on the elements of time, quality, and cost, using modern administrative and technical solutions that ensure efficient and professional project execution."
        }
      },
      { type: "BusinessScopeSection", props: {} },
      {
        type: "AboutVisionMissionGoalsSection",
        props: {
          visionAr: "أن تكون مكة البركة اسمًا رائدًا في مجال الطرق والأعمال الترابية والمحاجر في مصر والمنطقة.",
          visionEn: "To be Mecca El Baraka a leading name in the field of roads, earthworks and quarries in Egypt and the region.",
          missionAr: "نشر ثقافة الجودة وتقديم خدمات المقاولات بمعايير عالمية مع أفضل تكلفة وجودة.",
          missionEn: "Spreading a culture of quality and providing contracting services with international standards with the best cost and quality.",
          goalsAr: "الارتقاء بجودة جميع أعمالنا وتحقيق رضا العملاء وتقديم أعلى مستويات السلامة والاحترافية.",
          goalsEn: "Elevating the quality of all our work, achieving customer satisfaction and providing the highest levels of safety and professionalism."
        }
      },
      {
        type: "AboutCoreValuesSection",
        props: {
          values: [
            { icon: "FaCheckCircle", ar: "الجودة", en: "Quality", color: "text-blue-600" },
            { icon: "FaShieldAlt", ar: "السلامة", en: "Safety", color: "text-green-600" },
            { icon: "FaHandshake", ar: "النزاهة", en: "Integrity", color: "text-purple-600" },
            { icon: "FaLightbulb", ar: "الابتكار", en: "Innovation", color: "text-yellow-600" },
            { icon: "FaAward", ar: "التميز", en: "Excellence", color: "text-red-600" },
            { icon: "FaHandshake", ar: "الشراكة طويلة الأمد", en: "Long-term Partnership", color: "text-indigo-600" }
          ]
        }
      },
      {
        type: "AboutWhyUsSection",
        props: {
          titleAr: "لماذا نحن؟",
          titleEn: "Why Choose Us?",
          showSection: true,
          layout: "grid",
          backgroundColor: "from-blue-50 to-gray-100",
          points: [
            { 
              icon: "FaAward", 
              number: "11+", 
              startNumber: 0, 
              endNumber: 11, 
              duration: 2000,
              ar: "سنة خبرة", 
              en: "Years Experience", 
              color: "bg-blue-500",
              iconColor: "#ffffff"
            },
            { 
              icon: "FaUsers", 
              number: "50+", 
              startNumber: 0, 
              endNumber: 50, 
              duration: 2000,
              ar: "مهندس محترف", 
              en: "Professional Engineers", 
              color: "bg-green-500",
              iconColor: "#ffffff"
            },
            { 
              icon: "FaBuilding", 
              number: "200+", 
              startNumber: 0, 
              endNumber: 200, 
              duration: 3000,
              ar: "مشروع منجز", 
              en: "Completed Projects", 
              color: "bg-purple-500",
              iconColor: "#ffffff"
            },
            { 
              icon: "FaHeart", 
              number: "98%", 
              startNumber: 0, 
              endNumber: 98, 
              duration: 2500,
              ar: "رضا العملاء", 
              en: "Client Satisfaction", 
              color: "bg-red-500",
              iconColor: "#ffffff"
            },
            { 
              icon: "FaShieldAlt", 
              number: "100%", 
              startNumber: 0, 
              endNumber: 100, 
              duration: 2000,
              ar: "جودة معتمدة", 
              en: "Certified Quality", 
              color: "bg-indigo-500",
              iconColor: "#ffffff"
            }
          ]
        }
      },
      {
        type: "AboutTestimonialsSection",
        props: {
          testimonials: [
            {
              name: "أحمد محمد",
              position: "مدير مشروع",
              company: "شركة البناء الحديثة",
              content: "خبرة 11 عاماً تتحدث عن نفسها. شركة مكة البركة من أفضل شركات المقاولات في مصر. الجودة والالتزام بالمواعيد ممتاز.",
              rating: 5
            },
            {
              name: "سارة أحمد",
              position: "مدير تطوير",
              company: "مجموعة الاستثمار العقاري",
              content: "تعاملنا مع الشركة في عدة مشاريع وكانت النتائج مبهرة. الفريق محترف والجودة عالية جداً.",
              rating: 5
            },
            {
              name: "محمد علي",
              position: "رئيس مجلس إدارة",
              company: "شركة الطرق السريعة",
              content: "شركة مكة البركة شريك استراتيجي موثوق. نثق في خبرتهم وقدرتهم على تنفيذ المشاريع المعقدة.",
              rating: 5
            }
          ]
        }
      },
      {
        type: "AboutCTASection",
        props: {
          titleAr: "جاهزون لتحقيق رؤيتكم…",
          titleEn: "Ready to build your vision?",
          descriptionAr: "تواصل معنا اليوم لبدء مشروعك مع مكة البركة للمقاولات.",
          descriptionEn: "Contact us today to start your project with Mecca El Baraka For Construction.",
          buttonTextAr: "تواصل معنا",
          buttonTextEn: "Contact Us",
          backgroundImage: "/images/about-cta.jpg",
          backgroundAlt: ""
        }
      }
    ]
  },
  services: {
    id: "services",
    title: "خدماتنا",
    sections: [
      {
        type: "HeroSection",
        props: {
          headline: {
            ar: "خدماتنا المتكاملة",
            en: "Our Integrated Services"
          },
          subheadline: {
            ar: "نقدم مجموعة شاملة من الخدمات في مجال البناء والتشييد، من التصميم إلى التنفيذ والصيانة، مع ضمان أعلى معايير الجودة والسلامة",
            en: "We provide a comprehensive range of services in construction and contracting, from design to implementation and maintenance, ensuring the highest standards of quality and safety"
          },
          images: [
            "/images/image1.jpg",
            "/images/image2.jpg"
          ]
        }
      },
      {
        type: "ServicesGridSection",
        props: {
          services: [
            {
              id: 1,
              titleAr: 'المقاولات العامة',
              titleEn: 'General Contracting',
              descriptionAr: 'نقدم خدمات المقاولات العامة لجميع أنواع المشاريع السكنية والتجارية والصناعية',
              descriptionEn: 'We provide general contracting services for all types of residential, commercial, and industrial projects',
              featuresAr: [
                'بناء المباني السكنية والتجارية',
                'تطوير المجمعات السكنية',
                'بناء المراكز التجارية',
                'تشييد المصانع والمستودعات',
                'إعادة التأهيل والتجديد'
              ],
              featuresEn: [
                'Construction of residential and commercial buildings',
                'Development of residential complexes',
                'Construction of shopping centers',
                'Construction of factories and warehouses',
                'Rehabilitation and renovation'
              ],
              image: '/images/image1.jpg'
            },
            {
              id: 2,
              titleAr: 'استخراج المحاجر',
              titleEn: 'Quarry Extraction',
              descriptionAr: 'متخصصون في استخراج وتجهيز المواد الخام من المحاجر لجميع أنواع البناء',
              descriptionEn: 'Specialists in extracting and processing raw materials from quarries for all types of construction',
              featuresAr: [
                'استخراج الحجر الجيري',
                'تجهيز الرمل والحصى',
                'إنتاج الخرسانة الجاهزة',
                'تجهيز مواد البناء',
                'نقل وتوريد المواد'
              ],
              featuresEn: [
                'Limestone extraction',
                'Sand and gravel processing',
                'Ready-mix concrete production',
                'Building materials processing',
                'Transport and supply of materials'
              ],
              image: '/images/image2.jpg'
            },
            {
              id: 3,
              titleAr: 'البنية التحتية',
              titleEn: 'Infrastructure',
              descriptionAr: 'تطوير وتنفيذ مشاريع البنية التحتية المتطورة والمرافق العامة',
              descriptionEn: 'Development and implementation of advanced infrastructure projects and public facilities',
              featuresAr: [
                'تطوير الطرق والجسور',
                'شبكات المياه والصرف الصحي',
                'شبكات الكهرباء والاتصالات',
                'مشاريع الري والزراعة',
                'المرافق العامة'
              ],
              featuresEn: [
                'Road and bridge development',
                'Water and sewage networks',
                'Electricity and communications networks',
                'Irrigation and agriculture projects',
                'Public facilities'
              ],
              image: '/images/image3.jpg'
            },
            {
              id: 4,
              titleAr: 'التصميم المعماري',
              titleEn: 'Architectural Design',
              descriptionAr: 'تصميم المباني والمنشآت بأحدث التقنيات والمواد المستدامة',
              descriptionEn: 'Designing buildings and facilities with the latest technologies and sustainable materials',
              featuresAr: [
                'التصميم المعماري الحديث',
                'التصميم الداخلي',
                'التصميم المستدام',
                'تصميم المناظر الطبيعية',
                'إدارة المشاريع'
              ],
              featuresEn: [
                'Modern architectural design',
                'Interior design',
                'Sustainable design',
                'Landscape design',
                'Project management'
              ],
              image: '/images/image4.jpg'
            },
            {
              id: 5,
              titleAr: 'الصيانة والتشغيل',
              titleEn: 'Maintenance & Operation',
              descriptionAr: 'خدمات الصيانة الدورية والتشغيل للمنشآت والمباني',
              descriptionEn: 'Periodic maintenance and operation services for facilities and buildings',
              featuresAr: [
                'الصيانة الوقائية',
                'الصيانة التصحيحية',
                'إدارة المرافق',
                'خدمات النظافة',
                'إدارة الأمن والسلامة'
              ],
              featuresEn: [
                'Preventive maintenance',
                'Corrective maintenance',
                'Facility management',
                'Cleaning services',
                'Security and safety management'
              ],
              image: '/images/image1.jpg'
            },
            {
              id: 6,
              titleAr: 'الاستشارات الهندسية',
              titleEn: 'Engineering Consultations',
              descriptionAr: 'استشارات هندسية متخصصة في جميع مراحل المشروع من التخطيط إلى التنفيذ',
              descriptionEn: 'Specialized engineering consultations in all project phases from planning to implementation',
              featuresAr: [
                'دراسات الجدوى',
                'التخطيط الاستراتيجي',
                'إدارة المشاريع',
                'المراقبة والتفتيش',
                'التقييم والتدقيق'
              ],
              featuresEn: [
                'Feasibility studies',
                'Strategic planning',
                'Project management',
                'Monitoring and inspection',
                'Evaluation and auditing'
              ],
              image: '/images/image2.jpg'
            }
          ]
        }
      },
      {
        type: "ServicesCTASection",
        props: {
          titleAr: "هل تحتاج إلى استشارة مجانية؟",
          titleEn: "Need a Free Consultation?",
          descriptionAr: "فريقنا من الخبراء جاهز لمساعدتك في تخطيط وتنفيذ مشروعك بأفضل الطرق وأقل التكاليف",
          descriptionEn: "Our team of experts is ready to help you plan and execute your project in the best ways and at the lowest costs",
          buttonTextAr: "احصل على استشارة مجانية",
          buttonTextEn: "Get a Free Consultation"
        }
      }
    ]
  },
  projects: {
    id: "projects",
    title: "مشاريعنا",
    sections: [
      {
        type: "ProjectsHeroSection",
        props: {
          titleAr: "مشاريعنا المنجزة",
          titleEn: "Our Completed Projects",
          subtitleAr: "اكتشف مجموعة من مشاريعنا المنجزة بنجاح في مختلف المجالات، والتي تعكس خبرتنا الواسعة والتزامنا بالجودة العالية",
          subtitleEn: "Discover a collection of our successfully completed projects in various fields, reflecting our extensive experience and commitment to high quality"
        }
      },
      {
        type: "ProjectsGridSection",
        props: {
          projects: [
            {
              id: 1,
              titleAr: 'مشروع محجر الحجر الجيري - جبل المقطم',
              titleEn: 'Limestone Quarry Project - Mokattam Mountain',
              categoryAr: 'المحاجر والتعدين',
              categoryEn: 'Quarries & Mining',
              locationAr: 'جبل المقطم، القاهرة',
              locationEn: 'Mokattam Mountain, Cairo',
              date: '2023',
              descriptionAr: 'مشروع استخراج وتجهيز الحجر الجيري عالي الجودة من جبل المقطم، مع تطبيق أحدث تقنيات التعدين المستدامة',
              descriptionEn: 'High-quality limestone extraction and processing project from Mokattam Mountain, applying the latest sustainable mining technologies',
              image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
              areaAr: '100,000 متر مربع',
              areaEn: '100,000 sqm',
              durationAr: '36 شهر',
              durationEn: '36 months'
            },
            {
              id: 2,
              titleAr: 'مشروع تطوير طريق القاهرة - السويس',
              titleEn: 'Cairo - Suez Road Development Project',
              categoryAr: 'البنية التحتية',
              categoryEn: 'Infrastructure',
              locationAr: 'طريق القاهرة - السويس',
              locationEn: 'Cairo - Suez Road',
              date: '2022',
              descriptionAr: 'توسعة وتطوير الطريق الحيوي الذي يربط القاهرة بمدينة السويس، مع تنفيذ أعمال رصف حديثة وتحسينات مرورية',
              descriptionEn: 'Expansion and development of the vital road connecting Cairo to Suez city, with modern paving works and traffic improvements',
              image: 'https://images.unsplash.com/photo-1545454675-3531b543be5d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
              areaAr: '120 كم',
              areaEn: '120 km',
              durationAr: '24 شهر',
              durationEn: '24 months'
            },
            {
              id: 3,
              titleAr: 'مشروع محجر الجرانيت - أسوان',
              titleEn: 'Granite Quarry Project - Aswan',
              categoryAr: 'المحاجر والتعدين',
              categoryEn: 'Quarries & Mining',
              locationAr: 'أسوان، مصر',
              locationEn: 'Aswan, Egypt',
              date: '2023',
              descriptionAr: 'استخراج وتجهيز الجرانيت المصري عالي الجودة من محاجر أسوان الشهيرة، مع تطبيق معايير السلامة العالمية',
              descriptionEn: 'Extraction and processing of high-quality Egyptian granite from the famous Aswan quarries, applying international safety standards',
              image: 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
              areaAr: '75,000 متر مربع',
              areaEn: '75,000 sqm',
              durationAr: '30 شهر',
              durationEn: '30 months'
            },
            {
              id: 4,
              titleAr: 'مشروع مجمع سكني مكة البركة',
              titleEn: 'Mecca El Baraka Residential Complex',
              categoryAr: 'المباني السكنية',
              categoryEn: 'Residential Buildings',
              locationAr: 'القاهرة الجديدة',
              locationEn: 'New Cairo',
              date: '2023',
              descriptionAr: 'مجمع سكني متكامل يحتوي على 500 وحدة سكنية مع مرافق ترفيهية وتجارية متكاملة',
              descriptionEn: 'Integrated residential complex containing 500 housing units with integrated recreational and commercial facilities',
              image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
              areaAr: '150,000 متر مربع',
              areaEn: '150,000 sqm',
              durationAr: '42 شهر',
              durationEn: '42 months'
            },
            {
              id: 5,
              titleAr: 'مشروع محجر الرخام - المنيا',
              titleEn: 'Marble Quarry Project - Minya',
              categoryAr: 'المحاجر والتعدين',
              categoryEn: 'Quarries & Mining',
              locationAr: 'المنيا، مصر',
              locationEn: 'Minya, Egypt',
              date: '2022',
              descriptionAr: 'استخراج وتجهيز الرخام المصري عالي الجودة من محاجر المنيا، مع تطبيق تقنيات التعدين الحديثة',
              descriptionEn: 'Extraction and processing of high-quality Egyptian marble from Minya quarries, applying modern mining technologies',
              image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
              areaAr: '80,000 متر مربع',
              areaEn: '80,000 sqm',
              durationAr: '28 شهر',
              durationEn: '28 months'
            },
            {
              id: 6,
              titleAr: 'مشروع جسر النيل - الإسكندرية',
              titleEn: 'Nile Bridge Project - Alexandria',
              categoryAr: 'البنية التحتية',
              categoryEn: 'Infrastructure',
              locationAr: 'الإسكندرية، مصر',
              locationEn: 'Alexandria, Egypt',
              date: '2023',
              descriptionAr: 'إنشاء جسر حديث يربط ضفتي النيل في الإسكندرية، مع تطبيق أحدث تقنيات البناء والتصميم',
              descriptionEn: 'Construction of a modern bridge connecting the two banks of the Nile in Alexandria, applying the latest construction and design technologies',
              image: 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
              areaAr: '2.5 كم',
              areaEn: '2.5 km',
              durationAr: '36 شهر',
              durationEn: '36 months'
            },
            {
              id: 7,
              titleAr: 'مشروع مركز تجاري مكة البركة',
              titleEn: 'Mecca El Baraka Commercial Center',
              categoryAr: 'المباني التجارية',
              categoryEn: 'Commercial Buildings',
              locationAr: 'وسط البلد، القاهرة',
              locationEn: 'Downtown Cairo',
              date: '2023',
              descriptionAr: 'مركز تجاري حديث متعدد الطوابق مع أحدث التقنيات والتصميم المعماري المتميز',
              descriptionEn: 'Modern multi-story commercial center with the latest technologies and distinguished architectural design',
              image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
              areaAr: '45,000 متر مربع',
              areaEn: '45,000 sqm',
              durationAr: '30 شهر',
              durationEn: '30 months'
            },
            {
              id: 8,
              titleAr: 'مشروع محجر الحجر الرملي - سيناء',
              titleEn: 'Sandstone Quarry Project - Sinai',
              categoryAr: 'المحاجر والتعدين',
              categoryEn: 'Quarries & Mining',
              locationAr: 'شبه جزيرة سيناء',
              locationEn: 'Sinai Peninsula',
              date: '2022',
              descriptionAr: 'استخراج وتجهيز الحجر الرملي عالي الجودة من محاجر سيناء، مع الحفاظ على البيئة المحلية',
              descriptionEn: 'Extraction and processing of high-quality sandstone from Sinai quarries, while preserving the local environment',
              image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
              areaAr: '120,000 متر مربع',
              areaEn: '120,000 sqm',
              durationAr: '32 شهر',
              durationEn: '32 months'
            }
          ]
        }
      }
    ]
  },
  contact: {
    id: "contact",
    title: "اتصل بنا",
    sections: [
      {
        type: "ContactHeroSection",
        props: {
          titleAr: "اتصل بنا",
          titleEn: "Contact Us",
          subtitleAr: "نحن هنا لمساعدتك في تحقيق مشروعك",
          subtitleEn: "We are here to help you achieve your project"
        }
      },
      {
        type: "ContactInfoSection",
        props: {
          titleAr: "معلومات الاتصال",
          titleEn: "Contact Information",
          descriptionAr: "يمكنك التواصل معنا عبر الهاتف أو البريد الإلكتروني أو زيارة مقرنا",
          descriptionEn: "You can contact us by phone, email, or visit our headquarters"
        }
      }
    ]
  }
}; 